module.exports = __webpack_public_path__ + "static/img/bg-pt.a6e9f0c4.webp";